module.exports = __webpack_public_path__ + "img/maidian2.7e329d15.png";